import React from 'react'
import { ImageFit } from './ImageFit.component'
import { ThemeContext } from '../../../context'
import { IMAGE_PATHS_V2 } from '@/shared/consts/imagesPaths'

export const CreatorlandLogo = () => {
  const { theme } = React.useContext(ThemeContext)
  const logoPath = IMAGE_PATHS_V2.logos + theme + '/creatorland_logo_tx.svg'
  return <ImageFit src={logoPath} alt="Logo Creatorland Dark" />
}
